import { CSSProperties } from 'react';
import { useReduxState } from 'hooks';
import { wikiLangCodes } from 'lib/lang';
import { Tooltip } from 'components/common';

interface Props {
  lang: string;
  style?: CSSProperties;
  size?: 'small' | 'medium' | 'large';
  tooltipText?: string | React.ReactNode;
}

// a custom flag icon that uses icons from flag-icon-css package
// we use this, because importing the css from the npm package
// includes all svg files in the css bundle which becomes huge
const FlagIcon = ({ lang, style, size, tooltipText }: Props) => {
  const { theme } = useReduxState();

  // find the language object to check if it has a flag icon
  const langObj = wikiLangCodes.find((l) => l.value === lang);
  const hasFlagIcon = langObj && langObj.hasFlagIcon;

  const icon = (
    <div className={`flag-icon flag-${size}`} style={style}>
      {hasFlagIcon ? (
        <img
          alt={`${lang}-flag`}
          className="flag-icon-image"
          src={`/static/flag-icon-css/flags/4x3/${lang}.svg`}
        />
      ) : (
        // display a placeholder icon if the language does not have a flag svg
        <img
          alt="no-flag-placeholder"
          className="flag-icon-image"
          src="/static/flag-icon-css/flags/4x3/placeholder.svg"
        />
      )}
      <style jsx>{`
        .flag-icon {
          border: 1px solid ${theme.lightGreyActive};
          border-radius: 4px;
          display: inline-block;
          line-height: 0;
          overflow: hidden;
          position: relative;
          vertical-align: middle;
          width: 20px;
        }
        .flag-small {
          border-radius: 3px;
          width: 18px;
        }
        .flag-large {
          border-radius: 4px;
          width: 22px;
        }
        .flag-icon-image {
          display: block;
          height: 100%;
          max-width: 100%;
        }
      `}</style>
    </div>
  );

  return tooltipText ? (
    <Tooltip childrenWrapInDiv={false} content={tooltipText}>
      {icon}
    </Tooltip>
  ) : (
    icon
  );
};

export default FlagIcon;
